import SvgContainer from "../SvgContainer";

function SvgInkDrop( { width, height, color, ...remProps } ){
    return(
        <SvgContainer { ...remProps }
        width = { width }
        height = { height }
        fill="none" xmlns="http://www.w3.org/2000/svg"
        >
        <path d="M8 21.3333C3.58333 21.3333 0 17.75 0 13.3333C0 9.53333 5.425 2.40417 6.94167 0.4875C7.19167 0.175 7.5625 0 7.9625 0H8.0375C8.4375 0 8.80833 0.175 9.05833 0.4875C10.575 2.40417 16 9.53333 16 13.3333C16 17.75 12.4167 21.3333 8 21.3333ZM4 14C4 13.6333 3.7 13.3333 3.33333 13.3333C2.96667 13.3333 2.66667 13.6333 2.66667 14C2.66667 16.5792 4.75417 18.6667 7.33333 18.6667C7.7 18.6667 8 18.3667 8 18C8 17.6333 7.7 17.3333 7.33333 17.3333C5.49167 17.3333 4 15.8417 4 14Z" fill={color}/>
        </SvgContainer>
    )
}

export default SvgInkDrop;